export const SF_API_URL_CONFIG = {
  EVENTS: {
    CORPORATE: 'corporate-events',
  },
};
